import { render } from "./domain.vue?vue&type=template&id=0006f19c&scoped=true"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"

import "./domain.vue?vue&type=style&index=0&id=0006f19c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0006f19c"]])

export default __exports__